webpackJsonp([62],{

/***/ 1343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_job_description_vue__ = __webpack_require__(2172);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ee41185_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_job_description_vue__ = __webpack_require__(3156);
function injectStyle (ssrContext) {
  __webpack_require__(3146)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ee41185"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_job_description_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ee41185_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_job_description_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_card_vue__ = __webpack_require__(1374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51aa3bb1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_card_vue__ = __webpack_require__(1386);
function injectStyle (ssrContext) {
  __webpack_require__(1384)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51aa3bb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51aa3bb1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PCard',
	methods: {
		mouseOver: function mouseOver() {
			this.$emit('mouseleave');
		}
	}
});

/***/ }),

/***/ 1375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_button_vue__ = __webpack_require__(1376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a59afd1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_button_vue__ = __webpack_require__(1395);
function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a59afd1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a59afd1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PButton',
	props: {
		type: {
			default: function _default() {
				return 'primary';
			},
			validator: function validator(value) {
				return ['primary', 'secondary', 'black'].includes(value);
			}
		},
		extended: {
			default: function _default() {
				return false;
			}
		},
		outlined: {
			default: function _default() {
				return false;
			}
		},
		disabled: {
			default: function _default() {
				return false;
			}
		},
		minWidth: {
			default: function _default() {
				return 'auto';
			}
		},
		roundedLevel: {
			default: function _default() {
				return 'rounded-full';
			},
			validator: function validator(value) {
				return ['rounded', 'rounded-full'].includes(value);
			}
		},
		size: {
			default: 'normal',
			validator: function validator(value) {
				return ['xsmall', 'small', 'normal', 'large'].includes(value);
			}
		}
	},
	computed: {
		customClass: function customClass() {
			return [{
				primary: this.type === 'primary',
				secondary: this.type === 'secondary',
				black: this.type === 'black',
				outlined: this.outlined
			}, this.extended ? 'custom-button--px-14' : 'custom-button--px-8', this.roundedLevel === 'rounded' ? 'custom-button-rounded' : '', this.roundedLevel === 'rounded-full' ? 'custom-button-rounded-full' : '', this.size === 'xsmall' ? 'v-btn--xsmall custom-button--xsmall' : '', this.size === 'small' ? 'v-btn--small custom-button--small' : '', this.size === 'large' ? 'v-btn--large custom-button--large' : '', this.disabled ? 'v-btn--disabled' : ''];
		}
	}
});

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1385);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("728ecc96", content, true, {});

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.card[data-v-51aa3bb1]{padding:20px;border-radius:9px;border:1px solid #e9e9e9;background-color:#fff}", "", {"version":3,"sources":["/opt/build/repo/src/modules/shared/components/ui/Card/p-card.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,uBACE,aAAc,AACd,kBAAmB,AACnB,yBAA0B,AAC1B,qBAA0B,CAC3B","file":"p-card.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.card[data-v-51aa3bb1] {\n  padding: 20px;\n  border-radius: 9px;\n  border: solid 1px #e9e9e9;\n  background-color: #ffffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",on:{"mouseleave":_vm.mouseOver}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PHorizontalDivider',
	props: {
		mx: {
			default: function _default() {
				return '-20px';
			}
		},
		my: {
			default: function _default() {
				return '20px';
			}
		}
	}
});

/***/ }),

/***/ 1390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_horizontal_divider_vue__ = __webpack_require__(1387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e04d454_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_horizontal_divider_vue__ = __webpack_require__(1420);
function injectStyle (ssrContext) {
  __webpack_require__(1418)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e04d454"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_horizontal_divider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e04d454_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_horizontal_divider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("e5b9defa", content, true, {});

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.custom-button--px-8[data-v-4a59afd1]{padding-left:2rem!important;padding-right:2rem!important}.custom-button--px-14[data-v-4a59afd1]{padding-left:3.5rem!important;padding-right:3.5rem!important}", "", {"version":3,"sources":["/opt/build/repo/src/modules/shared/components/ui/p-button.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,sCACE,4BAA8B,AAC9B,4BAA+B,CAChC,AACD,uCACE,8BAAgC,AAChC,8BAAiC,CAClC","file":"p-button.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.custom-button--px-8[data-v-4a59afd1] {\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n.custom-button--px-14[data-v-4a59afd1] {\n  padding-left: 3.5rem !important;\n  padding-right: 3.5rem !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"custom-button v-btn",class:_vm.customClass,style:({ minWidth: _vm.minWidth }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1419);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("175a4f01", content, true, {});

/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.divider[data-v-7e04d454]{border-top:1px solid #e9e9e9}", "", {"version":3,"sources":["/opt/build/repo/src/modules/shared/components/ui/p-horizontal-divider.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,0BACE,4BAA8B,CAC/B","file":"p-horizontal-divider.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.divider[data-v-7e04d454] {\n  border-top: solid 1px #e9e9e9;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider",style:({ marginLeft: _vm.mx, marginRight: _vm.mx, marginTop: _vm.my, marginBottom: _vm.my })})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'title-header',
	props: {
		gray: {
			type: Boolean,
			default: false
		},
		pbZero: {
			type: Boolean,
			default: false
		},
		pollName: String,
		title: String,
		urlImage: String
	}
});

/***/ }),

/***/ 1487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_title_header_vue__ = __webpack_require__(1460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbead12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_title_header_vue__ = __webpack_require__(1490);
function injectStyle (ssrContext) {
  __webpack_require__(1488)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdbead12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_title_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbead12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_title_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1489);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("6a611bf6", content, true, {});

/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.title-header .text[data-v-bdbead12]{font-family:NeuzeitGroTBold;font-size:18px}.title-header .wrapper[data-v-bdbead12]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e7e7e7;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px 10px}.title-header .wrapper.pb-0[data-v-bdbead12]{padding-bottom:0}.subtitle-header[data-v-bdbead12]{font-family:NeuzeitGroT;font-size:18px}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/title-header.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,4BAA+B,AAC/B,cAAgB,CACjB,AACD,wCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAiC,AACjC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,kBAAoB,CACrB,AACD,6CACI,gBAAoB,CACvB,AACD,kCACE,wBAA2B,AAC3B,cAAgB,CACjB","file":"title-header.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.title-header .text[data-v-bdbead12] {\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 18px;\n}\n.title-header .wrapper[data-v-bdbead12] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: 1px solid #e7e7e7;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 5px 10px;\n}\n.title-header .wrapper.pb-0[data-v-bdbead12] {\n    padding-bottom: 0px;\n}\n.subtitle-header[data-v-bdbead12] {\n  font-family: \"NeuzeitGroT\";\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-header"},[_c('div',{staticClass:"wrapper",class:{ 'pb-0': _vm.pbZero }},[_c('div',[(_vm.urlImage)?_c('img',{staticClass:"mr-2",attrs:{"src":_vm.urlImage,"alt":_vm.urlImage}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text",style:(("color:" + (_vm.gray ? _vm.$appColors.info : _vm.$appColors.primary)))},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.title)+" "),(_vm.pollName)?_c('span',{staticClass:"subtitle-header"},[_vm._v("- "+_vm._s(_vm.pollName))]):_vm._e()])]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_diagnosis_title_header__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_job_profile_components_content_p_title_header__ = __webpack_require__(3148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_shared_components_ui_Card_p_card__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_shared_components_ui_p_button__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_job_profile_components_content_p_instruction_item__ = __webpack_require__(3152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_shared_components_ui_p_horizontal_divider__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_helper__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ramda__ = __webpack_require__(17);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var _ref2, response, responsables, dataResponsables;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$httpPraktiko.get('job-description/detail-profile/' + this.selectedJob.id);

					case 3:
						_ref2 = _context.sent;
						response = _ref2.data;

						this.jobInfo = response.additionalInformation || {};
						if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.jobInfo).length === 0) {
							this.showNotification('Este Puesto no cuenta con su Descripción', 'warning');
							this.goTo('new-profile');
						}
						this.descriptionData = response;
						this.jobSelected = response.job;
						this.stepsData = response.steps;
						responsables = this.stepsData.MECM.description;
						dataResponsables = responsables.map(function (lr) {
							var matchRes = _this.responsability.find(function (r) {
								return r.id === lr.id;
							});
							if (matchRes) {
								return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, lr, {
									description: matchRes.description
								});
							}
							return lr;
						});

						this.stepsData.MECM.description = dataResponsables;
						_context.next = 18;
						break;

					case 15:
						_context.prev = 15;
						_context.t0 = _context['catch'](0);

						if (_context.t0.status === 400) {
							if (_context.t0.data.message === 'JOB_PROFILE_NOT_FOUND') {
								this.showNotification('Este Puesto no cuenta con su Descripción', 'warning');
								this.goTo('new-profile');
							} else {
								this.showGenericError();
							}
						} else {
							this.showGenericError();
						}

					case 18:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 15]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var downloadReportExcel = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
		var type = _ref4.type,
		    contentType = _ref4.contentType;

		var body, _ref5, pdfData, blob;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						body = {
							jobId: this.selectedJob.id
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$httpPraktiko.post('reports/job-profile/excel', body, { responseType: 'blob' });

					case 4:
						_ref5 = _context2.sent;
						pdfData = _ref5.data;
						blob = generateBlob(pdfData, contentType);

						showDownloadDialog(blob, 'descripcion-puesto-' + this.selectedJob.name, type);
						this.showNotification('Reporte Generado Exitosamente');
						_context2.next = 14;
						break;

					case 11:
						_context2.prev = 11;
						_context2.t0 = _context2['catch'](1);

						this.showGenericError();

					case 14:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 11]]);
	}));

	return function downloadReportExcel(_x) {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var getLocalData = __WEBPACK_IMPORTED_MODULE_10__shared_helper__["a" /* default */].getLocalData,
    generateBlob = __WEBPACK_IMPORTED_MODULE_10__shared_helper__["a" /* default */].generateBlob,
    showDownloadDialog = __WEBPACK_IMPORTED_MODULE_10__shared_helper__["a" /* default */].showDownloadDialog;


function created() {
	this.loadData();
}

function mounted() {}

function downloadReport() {
	window.open(this.descriptionData.urlFile, '_blank');
}

function getSubsidiaries() {
	var nameSubsidiaries = this.descriptionData.subsidiary.map(function (ds) {
		return ds.name;
	});
	return nameSubsidiaries.length > 0 ? nameSubsidiaries.join(', ') : '';
}

function getJobsHeReplaces() {
	if (this.jobSelected.additionalInformation && this.jobSelected.additionalInformation.jobHeReplaces && this.jobSelected.additionalInformation.jobHeReplaces.length > 0) {
		var jobsHeReplaces = this.jobSelected.additionalInformation.jobHeReplaces.map(function (jHR) {
			return jHR.name;
		});
		return jobsHeReplaces.length > 0 ? jobsHeReplaces.join(', ') : '';
	}
	return '';
}

function getJobsItReplaces() {
	if (this.jobSelected.additionalInformation && this.jobSelected.additionalInformation.jobItReplaces && this.jobSelected.additionalInformation.jobItReplaces.length > 0) {
		var jobsItReplaces = this.jobSelected.additionalInformation.jobItReplaces.map(function (jIR) {
			return jIR.name;
		});
		return jobsItReplaces.length > 0 ? jobsItReplaces.join(', ') : '';
	}
	return '';
}

function returnPage() {
	return this.flagEditProcess ? this.goTo('list-process-recruitment') : this.goTo('new-profile');
}

function data() {
	return {
		descriptionData: {
			subsidiary: [],
			job: {},
			steps: {},
			urlFile: null
		},
		jobInfo: {},
		stepsData: {
			MSJ: { description: [] },
			PSA: { description: [] },
			RNW: { description: [] },
			FINS: { description: { instructions: [] } },
			EXPR: { description: [] },
			MECM: { description: [] },
			RQSK: { description: [] },
			RDSK: { description: [] },
			RSID: { description: [] }
		},
		jobSelected: {
			name: '',
			role: { name: '' },
			areas: { name: '' },
			englishLevel: { name: '' },
			additionalInformation: {
				jobHeReplaces: [],
				jobItReplaces: [],
				immediateBoss: { name: '' }
			}
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'details-job-description',
	data: data,
	created: created,
	beforeCreate: function beforeCreate() {
		this.$store.dispatch('jobProfile/loadResponsabilities');
	},

	mounted: mounted,
	components: {
		titleHeader: __WEBPACK_IMPORTED_MODULE_4__components_diagnosis_title_header__["a" /* default */],
		PTitleHeader: __WEBPACK_IMPORTED_MODULE_5__modules_job_profile_components_content_p_title_header__["a" /* default */],
		PCard: __WEBPACK_IMPORTED_MODULE_6__modules_shared_components_ui_Card_p_card__["a" /* default */],
		PButton: __WEBPACK_IMPORTED_MODULE_7__modules_shared_components_ui_p_button__["a" /* default */],
		PInstructionItem: __WEBPACK_IMPORTED_MODULE_8__modules_job_profile_components_content_p_instruction_item__["a" /* default */],
		PHorizontalDivider: __WEBPACK_IMPORTED_MODULE_9__modules_shared_components_ui_p_horizontal_divider__["a" /* default */]
	},
	methods: {
		loadData: loadData,
		downloadReport: downloadReport,
		downloadReportExcel: downloadReportExcel,
		returnPage: returnPage
	},
	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["d" /* mapState */])('jobProfile', {
		selectedJob: function selectedJob(state) {
			return Object(__WEBPACK_IMPORTED_MODULE_12_ramda__["P" /* pathOr */])(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
		},

		responsability: Object(__WEBPACK_IMPORTED_MODULE_12_ramda__["P" /* pathOr */])([], ['descriptionData', 'responsabilities'])
	}), Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["d" /* mapState */])('recruitment', {
		flagEditProcess: Object(__WEBPACK_IMPORTED_MODULE_12_ramda__["P" /* pathOr */])(false, ['recruitmentFlow', 'flagEditProcess'])
	}), {
		getSubsidiaries: getSubsidiaries,
		getJobsHeReplaces: getJobsHeReplaces,
		getJobsItReplaces: getJobsItReplaces
	})
});

/***/ }),

/***/ 2173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'p-title-header',
	props: {
		gray: {
			type: Boolean,
			default: false
		},
		pbZero: {
			type: Boolean,
			default: false
		},
		pollName: String,
		title: String,
		urlImage: String
	}
});

/***/ }),

/***/ 2174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_shared_components_ui_p_button__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_shared_components_ui_p_horizontal_divider__ = __webpack_require__(1390);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {}

function setCareer(careers) {
	this.$emit('career-select', careers);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'InstructionItem',
	created: created,
	props: ['item', 'selectData', 'careerReturn', 'index'],
	components: { PButton: __WEBPACK_IMPORTED_MODULE_0__modules_shared_components_ui_p_button__["a" /* default */], PHorizontalDivider: __WEBPACK_IMPORTED_MODULE_1__modules_shared_components_ui_p_horizontal_divider__["a" /* default */] },
	methods: {
		setCareer: setCareer
	}
});

/***/ }),

/***/ 3146:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("50e7d1aa", content, true, {});

/***/ }),

/***/ 3147:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.header-title[data-v-4ee41185]{color:#f09c2b;font-size:18px;text-transform:capitalize;font-weight:700}.header-job[data-v-4ee41185]{color:#545a54;font-size:18px;text-transform:uppercase;font-weight:700}.btn-primary[data-v-4ee41185]{background-color:#5ed52b;width:34px!important;height:30px}.btn-primary[data-v-4ee41185],.btn-secondary[data-v-4ee41185]{color:#fff!important;font-family:NeuzeitGroTBold;font-size:16px;border-radius:20px;padding:0!important;margin:0!important}.btn-secondary[data-v-4ee41185]{background-color:#ffb74c;width:24px!important;height:24px}.column table[data-v-4ee41185]{margin:10px 0;width:100%;text-align:center}.column table th[data-v-4ee41185]{color:#fff;font-weight:\"NeuzeitGroTBold\";font-size:16px;background-color:#55ac4b;border-radius:4px}.column table tr .verb[data-v-4ee41185]{color:#f09c2b!important;font-size:16px;padding:10px 0;border-bottom:1px solid #e7e7e7}.column table tr .complement[data-v-4ee41185]{color:#a3a3a3!important;font-size:16px;text-align:left!important;border-bottom:1px solid #e7e7e7}.column table tr .verb1[data-v-4ee41185]{color:#f09c2b!important;font-size:16px;padding:10px 0;position:relative}.column table tr .verb1 .icon[data-v-4ee41185]{position:absolute;right:-15px;bottom:2px}.column table tr .complement1[data-v-4ee41185]{color:#a3a3a3!important;font-size:16px}.column table tr .result[data-v-4ee41185]{color:#a3a3a3!important;font-size:16px;padding:10px 0}.item-list-header[data-v-4ee41185]{background-color:var(--app-color-primary);border-radius:5px}.item-list-header span[data-v-4ee41185]{color:#fff!important;font-weight:700}.item-list-card[data-v-4ee41185]{margin:0!important;padding:20px!important}.item-list-card p[data-v-4ee41185]{color:#a3a3a3;font-size:16px}.item-list-title-item[data-v-4ee41185]{font-size:20px!important;color:#545a54!important;font-family:NeuzeitGroTBold}.item-list-subtitle-item[data-v-4ee41185]{font-size:14px!important;color:#55ac4b!important;font-family:NeuzeitGroTBold!important}", "", {"version":3,"sources":["/opt/build/repo/src/modules/job-profile/pages/details-job-description/details-job-description.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,+BACE,cAAe,AACf,eAAgB,AAChB,0BAA2B,AAC3B,eAAkB,CACnB,AACD,6BACE,cAAe,AACf,eAAgB,AAChB,yBAA0B,AAC1B,eAAkB,CACnB,AACD,8BAEE,yBAA0B,AAI1B,qBAAuB,AACvB,WAAa,CAGd,AACD,8DAVE,qBAA0B,AAE1B,4BAA+B,AAC/B,eAAgB,AAChB,mBAAoB,AAGpB,oBAAsB,AACtB,kBAAqB,CAYtB,AAVD,gCAEE,yBAA0B,AAI1B,qBAAuB,AACvB,WAAa,CAGd,AACD,+BACE,cAAe,AACf,WAAY,AACZ,iBAAmB,CACpB,AACD,kCACI,WAAe,AACf,8BAA+B,AAC/B,eAAgB,AAChB,yBAA0B,AAC1B,iBAAmB,CACtB,AACD,wCACI,wBAA0B,AAC1B,eAAgB,AAChB,eAAgB,AAChB,+BAAiC,CACpC,AACD,8CACI,wBAA0B,AAC1B,eAAgB,AAChB,0BAA4B,AAC5B,+BAAiC,CACpC,AACD,yCACI,wBAA0B,AAC1B,eAAgB,AAChB,eAAgB,AAChB,iBAAmB,CACtB,AACD,+CACM,kBAAmB,AACnB,YAAa,AACb,UAAY,CACjB,AACD,+CACI,wBAA0B,AAC1B,cAAgB,CACnB,AACD,0CACI,wBAA0B,AAC1B,eAAgB,AAChB,cAAgB,CACnB,AACD,mCACE,0CAA2C,AAC3C,iBAAmB,CACpB,AACD,wCACI,qBAAwB,AACxB,eAAkB,CACrB,AACD,iCACE,mBAAqB,AACrB,sBAAyB,CAC1B,AACD,mCACI,cAAe,AACf,cAAgB,CACnB,AACD,uCACE,yBAA2B,AAC3B,wBAA0B,AAC1B,2BAA+B,CAChC,AACD,0CACE,yBAA2B,AAC3B,wBAA0B,AAC1B,qCAA0C,CAC3C","file":"details-job-description.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.header-title[data-v-4ee41185] {\n  color: #f09c2b;\n  font-size: 18px;\n  text-transform: capitalize;\n  font-weight: bold;\n}\n.header-job[data-v-4ee41185] {\n  color: #545a54;\n  font-size: 18px;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n.btn-primary[data-v-4ee41185] {\n  color: #ffffff !important;\n  background-color: #5ed52b;\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 16px;\n  border-radius: 20px;\n  width: 34px !important;\n  height: 30px;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.btn-secondary[data-v-4ee41185] {\n  color: #ffffff !important;\n  background-color: #FFB74C;\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 16px;\n  border-radius: 20px;\n  width: 24px !important;\n  height: 24px;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.column table[data-v-4ee41185] {\n  margin: 10px 0;\n  width: 100%;\n  text-align: center;\n}\n.column table th[data-v-4ee41185] {\n    color: #ffffff;\n    font-weight: \"NeuzeitGroTBold\";\n    font-size: 16px;\n    background-color: #55ac4b;\n    border-radius: 4px;\n}\n.column table tr .verb[data-v-4ee41185] {\n    color: #f09c2b !important;\n    font-size: 16px;\n    padding: 10px 0;\n    border-bottom: 1px solid #e7e7e7;\n}\n.column table tr .complement[data-v-4ee41185] {\n    color: #a3a3a3 !important;\n    font-size: 16px;\n    text-align: left !important;\n    border-bottom: 1px solid #e7e7e7;\n}\n.column table tr .verb1[data-v-4ee41185] {\n    color: #f09c2b !important;\n    font-size: 16px;\n    padding: 10px 0;\n    position: relative;\n}\n.column table tr .verb1 .icon[data-v-4ee41185] {\n      position: absolute;\n      right: -15px;\n      bottom: 2px;\n}\n.column table tr .complement1[data-v-4ee41185] {\n    color: #a3a3a3 !important;\n    font-size: 16px;\n}\n.column table tr .result[data-v-4ee41185] {\n    color: #a3a3a3 !important;\n    font-size: 16px;\n    padding: 10px 0;\n}\n.item-list-header[data-v-4ee41185] {\n  background-color: var(--app-color-primary);\n  border-radius: 5px;\n}\n.item-list-header span[data-v-4ee41185] {\n    color: white !important;\n    font-weight: bold;\n}\n.item-list-card[data-v-4ee41185] {\n  margin: 0 !important;\n  padding: 20px !important;\n}\n.item-list-card p[data-v-4ee41185] {\n    color: #a3a3a3;\n    font-size: 16px;\n}\n.item-list-title-item[data-v-4ee41185] {\n  font-size: 20px !important;\n  color: #545a54 !important;\n  font-family: \"NeuzeitGroTBold\";\n}\n.item-list-subtitle-item[data-v-4ee41185] {\n  font-size: 14px !important;\n  color: #55ac4b !important;\n  font-family: \"NeuzeitGroTBold\" !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_title_header_vue__ = __webpack_require__(2173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791686fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_title_header_vue__ = __webpack_require__(3151);
function injectStyle (ssrContext) {
  __webpack_require__(3149)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-791686fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_title_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791686fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_title_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3149:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3150);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("0ac464dc", content, true, {});

/***/ }),

/***/ 3150:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.title-header .text[data-v-791686fb]{font-family:NeuzeitGroTBold;font-size:18px}.title-header .wrapper[data-v-791686fb]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e7e7e7;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px 10px}.title-header .wrapper.pb-0[data-v-791686fb]{padding-bottom:0}.subtitle-header[data-v-791686fb]{font-family:NeuzeitGroT;font-size:18px}", "", {"version":3,"sources":["/opt/build/repo/src/modules/job-profile/components/content/p-title-header.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,4BAA+B,AAC/B,cAAgB,CACjB,AACD,wCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAiC,AACjC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,kBAAoB,CACrB,AACD,6CACI,gBAAoB,CACvB,AACD,kCACE,wBAA2B,AAC3B,cAAgB,CACjB","file":"p-title-header.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.title-header .text[data-v-791686fb] {\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 18px;\n}\n.title-header .wrapper[data-v-791686fb] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: 1px solid #e7e7e7;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 5px 10px;\n}\n.title-header .wrapper.pb-0[data-v-791686fb] {\n    padding-bottom: 0px;\n}\n.subtitle-header[data-v-791686fb] {\n  font-family: \"NeuzeitGroT\";\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-header"},[_c('div',{staticClass:"wrapper",class:{ 'pb-0': _vm.pbZero }},[_c('div',{staticClass:"tw-w-full"},[(_vm.urlImage)?_c('img',{staticClass:"mr-2",attrs:{"src":_vm.urlImage,"alt":_vm.urlImage}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text",style:(("color:" + (_vm.gray ? _vm.$appColors.info : _vm.$appColors.primary)))},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.title)+" "),(_vm.pollName)?_c('span',{staticClass:"subtitle-header"},[_vm._v("- "+_vm._s(_vm.pollName))]):_vm._e()])]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_instruction_item_vue__ = __webpack_require__(2174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dfc62da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_instruction_item_vue__ = __webpack_require__(3155);
function injectStyle (ssrContext) {
  __webpack_require__(3153)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_instruction_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dfc62da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_instruction_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3153:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3154);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("543dd44a", content, true, {});

/***/ }),

/***/ 3154:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.instruction-item{border:1px solid var(--app-color-gray);border-radius:10px}.instruction-item .title{color:#545a54;font-size:16px!important}.tags{border:1px solid #f09c2b;color:#ffb74c!important;background-color:#fff5e6!important;font-family:NeuzeitGroTBold}", "", {"version":3,"sources":["/opt/build/repo/src/modules/job-profile/components/content/p-instruction-item.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,kBACE,uCAAwC,AACxC,kBAAoB,CACrB,AACD,yBACI,cAAe,AACf,wBAA2B,CAC9B,AACD,MACE,yBAA0B,AAC1B,wBAA0B,AAC1B,mCAAqC,AACrC,2BAA+B,CAChC","file":"p-instruction-item.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.instruction-item {\n  border: 1px solid var(--app-color-gray);\n  border-radius: 10px;\n}\n.instruction-item .title {\n    color: #545a54;\n    font-size: 16px !important;\n}\n.tags {\n  border: 1px solid #f09c2b;\n  color: #FFB74C !important;\n  background-color: #FFF5E6 !important;\n  font-family: \"NeuzeitGroTBold\";\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruction-item tw-p-4 custom-fade-in"},[_c('div',{staticClass:"tw-flex tw-justify-between tw-items-center tw-gap-4"},[_c('span',{staticClass:"title"},[_c('b',[_vm._v(_vm._s(_vm.item.name))])])]),_vm._v(" "),_c('p-horizontal-divider',{attrs:{"mx":"-1rem","my":"1rem"}}),_vm._v(" "),_c('section',{},_vm._l((_vm.item.career),function(career,index){return _c('v-chip',{key:index,staticClass:"tags"},[_vm._v("\n\t\t"+_vm._s(career))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex-col tw--mx-3"},[_c('div',{staticClass:"px-3 tw-w-3/3"},[_c('title-header',{staticClass:"tw-my-4"},[_c('v-layout',{staticClass:"tw-justify-between tw-items-center",attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"wrapper-btns"},[_c('v-btn',{attrs:{"color":"primary btn-action"},on:{"click":_vm.returnPage}},[_c('img',{staticClass:"mr-4",attrs:{"src":"/static/img/icons/btn-right-arrow.webp","alt":"Atrás"}}),_vm._v("\n\t\t\t\t\t\tAtrás\n\t\t\t\t\t")])],1),_vm._v(" "),_c('div',{staticClass:"wrapper-btns tw-mr-10"},[_c('app-tooltip-button',{attrs:{"text":"Descargar reporte en EXCEL","img":"/static/img/icons/excel.webp","disabled":!_vm.descriptionData.urlFile},on:{"click-icon":function($event){_vm.downloadReportExcel({ type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' })}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"text":"Descargar reporte en PDF","img":"/static/img/icons/pdf.svg","disabled":!_vm.descriptionData.urlFile},on:{"click-icon":_vm.downloadReport}})],1)])],1),_vm._v(" "),_c('p-card',{staticClass:"tw-flex tw-gap-x-10 tw-mb-4"},[_c('div',{staticClass:"px-3 tw-w-1/2"},[_c('p',{staticClass:"header-title"},[_vm._v("Organización / Empresa: "),_c('span',{staticClass:"header-job"},[_vm._v(_vm._s(_vm.descriptionData.subsidiary.length > 0 ? _vm.descriptionData.subsidiary[0].company.name : ''))])]),_vm._v(" "),_c('p',{staticClass:"header-title"},[_vm._v("Nombre del Puesto: "),_c('span',{staticClass:"header-job"},[_vm._v(_vm._s(_vm.jobSelected.name))])]),_vm._v(" "),_c('p',{staticClass:"header-title"},[_vm._v("Rol: "),_c('span',{staticClass:"header-job"},[_vm._v(_vm._s(_vm.jobSelected.role.name))])]),_vm._v(" "),_c('p',{staticClass:"header-title"},[_vm._v("Puesto al que reemplaza: "),_c('span',{staticClass:"header-job"},[_vm._v(_vm._s(_vm.getJobsHeReplaces))])]),_vm._v(" "),_c('p',{staticClass:"header-title"},[_vm._v("Programa / Área: "),_c('span',{staticClass:"header-job"},[_vm._v(_vm._s(_vm.jobSelected.areas.name))])])]),_vm._v(" "),_c('div',{staticClass:"px-3 tw-w-1/2"},[_c('p',{staticClass:"header-title"},[_vm._v("Sucursal/es: "),_c('span',{staticClass:"header-job"},[_vm._v(" "+_vm._s(_vm.getSubsidiaries))])]),_vm._v(" "),_c('p',{staticClass:"header-title"},[_vm._v("Idioma inglés: "),_c('span',{staticClass:"header-job"},[_vm._v(_vm._s(_vm.jobSelected.englishLevel.name))])]),_vm._v(" "),_c('p',{staticClass:"header-title"},[_vm._v("Jefe Inmediato: "),_c('span',{staticClass:"header-job"},[_vm._v(_vm._s(_vm.jobSelected.additionalInformation && _vm.jobSelected.additionalInformation.immediateBoss
					? _vm.jobSelected.additionalInformation.immediateBoss.name : _vm.jobInfo.fatherName.name))])]),_vm._v(" "),_c('p',{staticClass:"header-title"},[_vm._v("Puesto que lo reemplaza: "),_c('span',{staticClass:"header-job"},[_vm._v(_vm._s(_vm.getJobsItReplaces))])])])]),_vm._v(" "),_c('p-card',{staticClass:"tw-flex-auto tw-flex tw-justify-between tw-my- tw-gap-x-20"},[_c('div',{staticClass:"tw-flex-1 tw-w-full tw-p-3 column"},[(_vm.stepsData.MSJ)?_c('div',{staticClass:"tw-flex tw-flex-col tw-mb-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t1\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.MSJ.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"¿Para qué está este puesto? ¿Cuál es el principal resultado, servicio o beneficio de este puesto?","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_c('table',[_c('tr',[_c('th',{staticStyle:{"width":"30%"}},[_vm._v("VERBO")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70%"}},[_vm._v("COMPLEMENTO")])]),_vm._v(" "),_vm._l((_vm.stepsData.MSJ.description),function(msj,index){return _c('tr',{key:index},[_c('td',{staticClass:"verb"},[_vm._v(_vm._s(msj.verb ? msj.verb.name: ''))]),_vm._v(" "),_c('td',{staticClass:"complement"},[_vm._v(_vm._s(msj.complement))])])})],2)]):_vm._e(),_vm._v(" "),(_vm.stepsData.PSA)?_c('div',{staticClass:"tw-flex tw-flex-col tw-my-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t2\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.PSA.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"Elegir y compilar aquí las principales actividades del puesto.","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_c('table',[_c('tr',[_c('th',{staticStyle:{"width":"30%"}},[_vm._v("ACTIVIDAD")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70%"}},[_vm._v("COMPLEMENTO")])]),_vm._v(" "),_vm._l((_vm.stepsData.PSA.description),function(psa,index){return _c('tr',{key:index},[_c('td',{staticClass:"verb"},[_vm._v(_vm._s(psa.activity.name))]),_vm._v(" "),_c('td',{staticClass:"complement"},[_vm._v(_vm._s(psa.complement))])])})],2)]):_vm._e(),_vm._v(" "),(_vm.stepsData.RNW)?_c('div',{staticClass:"tw-flex tw-flex-col tw-my-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t3\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.RNW.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"Información adquirida a través de educación formal, eventos de capacitación o autoformación","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_c('table',[_c('tr',[_c('th',{staticStyle:{"width":"40%"}},[_vm._v("REQ.SELEC./CAP")]),_vm._v(" "),_c('th',{staticStyle:{"width":"60%"}},[_vm._v("CONOCIMIENTO")])]),_vm._v(" "),_vm._l((_vm.stepsData.RNW.description),function(rnw,index){return _c('tr',{key:index},[_c('td',{staticClass:"verb"},[_vm._v(_vm._s(rnw.req.name))]),_vm._v(" "),_c('td',{staticClass:"complement"},[_vm._v(_vm._s(rnw.complement))])])})],2)]):_vm._e(),_vm._v(" "),(_vm.stepsData.FINS)?_c('div',{staticClass:"tw-flex tw-flex-col tw-mt-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t4\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.FINS.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"Registra los títulos académicos formales necesarios para un adecuado desempeño del puesto.","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_vm._l((_vm.stepsData.FINS.description.instructions),function(instruction,index){return _c('p-instruction-item',{key:index,staticClass:"tw-mt-6",attrs:{"item":instruction}})})],2):_vm._e(),_vm._v(" "),(_vm.stepsData.EXPR)?_c('div',{staticClass:"tw-flex tw-flex-col tw-my-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t5\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.EXPR.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"Experiencias Laborales necesarias para el puesto.","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_c('table',[_c('tr',[_c('th',{staticStyle:{"width":"40%"}},[_vm._v("EXPERIENCIA")]),_vm._v(" "),_c('th',{staticStyle:{"width":"60%"}},[_vm._v("DETALLE")])]),_vm._v(" "),_vm._l((_vm.stepsData.EXPR.description),function(exp,index){return _c('tr',{key:index},[_c('td',{staticClass:"verb"},[_vm._v(_vm._s(exp.experience.name))]),_vm._v(" "),_c('td',{staticClass:"complement"},[_vm._v(_vm._s(exp.detail))])])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tw-flex-1 tw-w-full tw-p-3 column"},[(_vm.stepsData.MECM)?_c('div',{staticClass:"tw-flex tw-flex-col tw-mb-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t6\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.MECM.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"Las responsabilidades a tener en consideración para el puesto.","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_c('table',[_c('tr',[_c('th',{staticStyle:{"width":"60%"}},[_vm._v("RESPONSABILIDAD")]),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_c('tr',{staticStyle:{"width":"100%"}},[_c('th',{attrs:{"colspan":"3"}},[_vm._v("RELEVANCIA")])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"min-width":"100px !important"}},[_vm._v("ALTO")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"100px !important"}},[_vm._v("MEDIO")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"100px !important"}},[_vm._v("BAJO")])])])]),_vm._v(" "),_vm._l((_vm.stepsData.MECM.description),function(res,index){return _c('tr',{key:index},[_c('td',{staticClass:"verb1"},[_c('div',{staticClass:"tw-flex tw-justify-center"},[_c('span',[_vm._v(_vm._s(res.name))]),_vm._v(" "),_c('app-tooltip-button',{staticClass:"icon",attrs:{"size":"18","text":res.description,"img":"/static/img/info.svg","disabled":""}})],1)]),_vm._v(" "),_vm._l((res.checks),function(check,indexC){return _c('td',{key:indexC,staticClass:"complement1"},[(check)?_c('img',{attrs:{"src":"/static/img/check.svg"}}):_c('img',{attrs:{"src":"/static/img/uncheck.svg"}})])})],2)})],2)]):_vm._e(),_vm._v(" "),(_vm.stepsData.RQSK)?_c('div',{staticClass:"tw-flex tw-flex-col tw-my-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t7\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.RQSK.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"Son comportamientos laborales automatizados por la práctica en la ejecución de la actividad.","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"item-list"},[_c('div',{staticClass:"text-uppercase item-list-header tw-px-10 tw-py-1 tw-flex tw-justify-items-start tw-my-3 tw-gap-x-20"},[_c('span',[_vm._v("NOMBRE DE DESTREZA")])]),_vm._v(" "),_vm._l((_vm.stepsData.RQSK.description),function(skill,index){return _c('div',{key:index,staticClass:"tw-my-1"},[_c('p-card',{staticClass:"item-list-card tw-flex tw-justify-between tw-items-center"},[_c('p',[_vm._v(_vm._s(skill.name))]),_vm._v(" "),_c('v-chip',{staticClass:"tags"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(skill.selectedLevel.name)+"\n\t\t\t\t\t\t\t\t\t")])],1)],1)})],2)]):_vm._e(),_vm._v(" "),(_vm.stepsData.RDSK)?_c('div',{staticClass:"tw-flex tw-flex-col tw-my-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t8\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.RDSK.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"Se debe registrar las competencias propias del puesto conforme el Diccionario vigente.","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"item-list"},[_c('div',{staticClass:"text-uppercase item-list-header tw-px-10 tw-py-1 tw-flex tw-justify-items-start tw-my-3 tw-gap-x-20"},[_c('span',[_vm._v("NOMBRE DE COMPETENCIAS")])]),_vm._v(" "),_vm._l((_vm.stepsData.RDSK.description),function(competence,index){return _c('div',{key:index,staticClass:"tw-my-1"},[_c('p-card',{staticClass:"item-list-card"},[_c('div',{staticClass:"tw-flex tw-justify-between tw-items-center tw-gap-4"},[_c('div',{staticClass:"tw-flex tw-flex-col tw-justify-center tw-m-0 tw-p-0 tw-items-center"},[_c('p',{staticClass:"item-list-title-item tw-mb-0"},[_vm._v(_vm._s(competence.name))]),_vm._v(" "),_c('span',{staticClass:"item-list-subtitle-item tw-mb-0"},[_vm._v(_vm._s(competence.parent.name))])]),_vm._v(" "),_c('v-chip',{staticClass:"tags"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(competence.selectedLevel.name)+"\n\t\t\t\t\t\t\t\t\t\t")])],1),_vm._v(" "),_c('p-horizontal-divider'),_vm._v(" "),_vm._l((competence.selectedQuestions),function(question,indexQ){return _c('div',{key:indexQ},[(competence.questionsType.key === 'thirdPerson')?_c('p',[_vm._v(_vm._s(question.thirdPerson))]):_c('p',[_vm._v(_vm._s(question.firstPerson))])])})],2)],1)})],2)]):_vm._e(),_vm._v(" "),(_vm.stepsData.RSID)?_c('div',{staticClass:"tw-flex tw-flex-col tw-my-8"},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-between tw-gap-x-4"},[_c('button',{staticClass:"btn-primary"},[_vm._v("\n\t\t\t\t\t\t9\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p-title-header',{staticClass:"tw-w-full",attrs:{"title":_vm.stepsData.RSID.name,"gray":""}},[_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end tw-items-center",staticStyle:{"height":"auto"}},[_c('app-tooltip-button',{attrs:{"text":"Considere las actividades esenciales o los objetivos de trabajo relacionados con los objetivos de área y escriba ¿Cómo medir su correcta ejecución?","img":"/static/img/circle-question.svg","disabled":""}})],1)])],1),_vm._v(" "),_c('table',[_c('tr',[_c('th',{staticStyle:{"width":"15%"}},[_vm._v("CANT.")]),_vm._v(" "),_c('th',{staticStyle:{"width":"65%"}},[_vm._v("CALIDAD")]),_vm._v(" "),_c('th',{staticStyle:{"width":"20%"}},[_vm._v("TIEMPO")])]),_vm._v(" "),_vm._l((_vm.stepsData.RSID.description),function(result,index){return _c('tr',{key:index},[_c('td',{staticClass:"result"},[_vm._v(_vm._s(result.quantityPorcent))]),_vm._v(" "),_c('td',{staticClass:"result"},[_vm._v(_vm._s(result.quality))]),_vm._v(" "),_c('td',{staticClass:"result"},[_vm._v(_vm._s(result.quantity)+" "+_vm._s(result.time.name))])])})],2)]):_vm._e()])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/62.f2e4372371a130682b5f.js